import {TreatwellCookieConsent} from '@treatwell/cookie-consent';

type ActiveGroup = ReturnType<
  Awaited<ReturnType<TreatwellCookieConsent>>['getActiveGroups']
>[number];

// Resolves once the user has dismissed the cookie banner, or had already. index.html loads TwCookieConsent.js
// before the bundle, so window.TreatwellCookieConsent is there unless the script failed to load.
export const hasCookieConsent = (group: ActiveGroup) => {
  if (typeof window.TreatwellCookieConsent === 'undefined') {
    return Promise.resolve(false);
  }
  return window
    .TreatwellCookieConsent()
    .then((api) => api.getActiveGroups().includes(group))
    .catch(() => false);
};
